import React, {useEffect, useRef, useState} from 'react';
import axios from "@common/axios";
import {MarkColor} from './Styles';
import GenericDialog from "@common/GenericDialog";
import MathJaxHTMLContent from "@common/MathJaxHTMLContent";

const TestQuestionResultDialog = props => {

    const {data, setData} = props;

    const [open, setOpen] = useState(false),
        [userInput, setUserInput] = useState(''),
        [solution, setSolution] = useState(''),
        [dialogContent, setDialogContent] = useState(''),
        [title, setTitle] = useState(''),
        [answerColor, setAnswerColor] = useState({});

    useEffect(() => {
        if (data !== null && data.testResultId !== null){
            loadTestQuestionResult(data);
            setTitle(data.title);
        }
    }, [data]);

    const loadTestQuestionResult = (request) =>{
        axios.get('/web/ui/test/testQuestionResult',{params: {userId:request.userId, questionId:request.questionId, testAssignmentId:request.testAssignmentId}})
            .then(response =>{
                setOpen(true);
                setDialogContent(response.data.questionBean.formattedInstructions);
                setSolution(response.data.questionBean.solution);
                if(response.data.userInput == undefined || response.data.skipped) {
                    setUserInput("I don't know");
                } else {
                    setUserInput(response.data.userInput.toUpperCase());
                }
                setAnswerColor({color:response.data.result ? MarkColor.CORRECT : MarkColor.INCORRECT});
            }).catch(error =>{
                console.error('Error loading test question result. ',error);
        });
    }
    const handleClose = (value) => {
        setOpen(false);
        setData(null);
    };

    return (
        <GenericDialog id="questionResultDialog" onClose={handleClose} open={open} title={'Question result'}>
            <>
                {props && data && data.studentName && <h3 style={{marginTop:0}}>{data.studentName}</h3>}
                <h4>{title}</h4>
                <MathJaxHTMLContent disableInputs={true} html={dialogContent}/>
                <p className="text-bold">
                    <p>Correct answer: </p>
                    <p><MathJaxHTMLContent style={{display:'inline-block'}} html={solution}/></p>
                </p>
                <p style={answerColor}>User answer: {userInput}</p>
            </>
        </GenericDialog>
    );
}
export default TestQuestionResultDialog;
